import { render, staticRenderFns } from "./SummaryCardColoursAndExtras.vue?vue&type=template&id=db1c4f6a&scoped=true&"
import script from "./SummaryCardColoursAndExtras.vue?vue&type=script&lang=js&"
export * from "./SummaryCardColoursAndExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1c4f6a",
  null
  
)

export default component.exports